import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import InputCustom from '../../../../components/elements/InputCustom';
import SelectDropDown from '../../../../components/elements/SelectDropDown';
import { loadZones } from '../../../../store/Actions/ActionZone';
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom';
import CustomTreeTableAssign from '../../../../components/table/CustomTreeTableAssign';
import { assignProduct } from '../../../../store/Actions/ActionProducts';
import InnerLoader from '../../../../components/general/inner-loader/InnerLoader';

function AssignProduct({ open, setOpen, id }) {
    const { dispatch, langLocal, navigate, mode } = AbstructVar()
    const { translate } = AbstructLang()
    const [quantity, setQuantity] = useState('')
    const [Load, setLoad] = useState(false)
    const { zone, loadingZone } = useSelectorCustom()
    const [zone_id, setzone_id] = useState(null)
    const [open2, setOpen2] = useState(false)
    const [open1, setOpen1] = useState(false)

    useEffect(() => {
        dispatch(loadZones())
    }, [])
    const columns = [translate('select'), translate('name'), translate('symbol')];
    const assign = () => {
        console.log('zone_id', zone_id)
        const state = {
            material_id: id,
            warehouse_zone_id: zone_id,
            quantity: parseInt(quantity)
        }
        dispatch(assignProduct(state, setLoad))
    }
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `pop_center1 ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className='div_pop_center' dir={langLocal === 'ar' ? "rtl" : "ltr"} style={{ width:'600px' }} >
                <br></br>
                <h2 style={{ marginBottom: "25px" }} className='add_zone' >{translate('assign_mat_to_zone')}</h2>
                {console.log('zone', zone)}
                <InputCustom
                    label='quantity'
                    iconType='pencil'
                    type='number'
                    onChange={(e) => setQuantity(e.target.value)}
                />
                {
                    !loadingZone ?
                        <CustomTreeTableAssign langLocal={langLocal} translate={translate} columns={columns} data={zone} open={open2} setOpen={setOpen2} setOpen1={setOpen1} setzone_id={setzone_id} />
                        : <InnerLoader />
                }

                <br></br>
                <button className='btn_top_table' onClick={assign} >
                    {
                        Load ? "Loading ..." :
                            translate('save')
                    }
                </button>
            </div>
        </RModal>
    )
}

export default AssignProduct